import React from 'react';

import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';

import { RootState } from '../../../../redux/store';
import { MODAL } from '../../../../redux/types';

import Icon from '../../icon/icon';
import PopupWrapper from '../popupWrapper/popupWrapper';

import '../multipleDownload/multipleDownload.scss';

export const SelectedDocsLimit: React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const reachedLimit = useSelector((state: RootState) => state.multipleDownload.reachedLimit);

  const close = () => {
    dispatch({ type: MODAL.CLOSE_REACHED_LIMIT_MODAL });
  };

  return reachedLimit && (
    <PopupWrapper className='error-popup-style' onClose={close}>
      <div className='multiple-download-modal-body'>
        <Icon name='far fa-circle-exclamation' className='danger-icon' />
        <span className='reached-limit-text-primary'>{t('DOCUMENTS_TABLE.REACHED_LIMIT_PRIMARY')}</span>
        <br />
        <span className='reached-limit-text-secondary'>{t('DOCUMENTS_TABLE.REACHED_LIMIT_SECONDARY')}</span>
      </div>
    </PopupWrapper>
  );
};

export default SelectedDocsLimit;
